module.exports = __webpack_public_path__ + "static/media/thumbnail-hatvan-fc-regi-lelato-bontasa.fccfecf5.jpg";